import MeasureVertical from "@/components/tables/plotItem/mapThing/measureVertical.js";
let measure,
  measureHeight,
  measureHeightList = [];
export default {
  components: {},
  props: {},
  data() {
    return {
      measure_show: true,
      isFold: false,
    };
  },
  mounted() {
    // this.$refs["multipleTable"].$nextTick(function () {
    //            this.escrollY(
    //              ".el-table__body-wrapper",
    //              ".el-table__header-wrapper"
    //            );
    // 		   console.log('触发！');
    //          })
    if (!measure) {
      measure = new mars3d.thing.Measure({
        //可设置文本样式
        label: {
          color: "#ffffff",
          font_family: "黑体",
          font_size: 20,
          background: false,
        },
      });
      this.$GLOBAL.map.addThing(measure);
    }
  },
  methods: {
    measureBox_close() {
      //this.measureTable_show=false;
      //alert("触发");
      // alert('触发！');
      this.$emit("measureBox_close");
    },
    measure_point() {
      measure.point();
    },
    measure_spaceDistance() {
      //measure.distanceSurface(); //贴地测量会导致变卡。
      measure.distance();
    },
    measure_triangleDistance() {
      measure.heightTriangle();
    },
    measure_spaceArea() {
      //measure.areaSurface();//贴地测量会导致变卡,而且测量模型时会导致地面也出现一个测量区域。
      measure.area({
        style: {
          // color: '#00fff2',
          // opacity: 0.4,
          // outline: true,
          // outlineColor: '#fafa5a',
          // outlineWidth: 1,
          clampToGround: true, //不贴地
        },
      });
    },
    measure_surfaceArea() {
      this.$message({
        message: "绘制完区域后请耐心等待一会哦~",
        type: "success",
        offset: 100,
        showClose: true,
        duration: 3000,
      });
      measure.areaSurface({ splitNum: 10 });
    },
    measure_clearResults() {
      measure.clear();
      measureHeightList.forEach((element) => {
        element.clear();
      });
      measureHeight = null;
      measureHeightList = [];
    },
    measure_vertical() {
      measureHeight = new MeasureVertical(this.$GLOBAL.map.viewer);
      measureHeight.activate();
      measureHeightList.push(measureHeight);
    },
  },
  destroyed() {
    this.$GLOBAL.map.removeThing(measure, true);
    measure = null;
    measureHeight?.clear();
  },
  watch: {},
};
//console.log(localStorage.getItem(ColorPicker));
